import getEANs from './getEANs';
import getCopyAndPaste from './getCopyAndPaste';
import axios from 'axios';

window.getEANs = getEANs;
window.getCopyAndPaste = getCopyAndPaste;

(window as any).zecaToken = async (
	pointOfSaleId = Redux('posReducer').selectedPos.id,
	customerId = Redux('customerReducer').data.id,
) => {
	const response = await fetch('https://api-dev.hymparhub.com.br/partner/authenticate', {
		headers: {
			'partner-origin': 'zeca-pdv',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${import.meta.env.VITE_ZECA_TOKEN}`,
		},
		method: 'POST',
		body: JSON.stringify({ pointOfSaleId, customerId }),
	});

	const data = await response.json();

	Redux.replaceToken(data.token);
};
